import { render } from "./Profile.vue?vue&type=template&id=5a3b65bd&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=5a3b65bd&scoped=true&lang=css"
import "./Profile.vue?vue&type=style&index=1&id=5a3b65bd&scoped=true&lang=css"
import "./Profile.vue?vue&type=style&index=2&id=5a3b65bd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a3b65bd"]])

export default __exports__